import { mockFilterItems } from './filters';

export const mockMetaKeys: string[] = Object.keys(mockFilterItems);
